import React from "react";
import { useState } from "react";
import "./Mode.css";
function Mode({ darkMode, setDarkMode }) {
  return (
    <div className="switcher">
      <input
        type="checkbox"
        id="toggle"
        className="toggle--checkbox"
        onClick={() => setDarkMode(!darkMode)}
      />
      <label htmlFor="toggle" className="toggle--label">
        {/*<span class="toggle--label-background"></span>*/}
      </label>
    </div>
  );
}

export default Mode;
